<template>
  <div class="LivePanelComponent">
    <b-alert :variant="variant" :class="{visible: libStatusOverall.length == 0}" show><span v-html="libStatusOverall"></span></b-alert>
    <!-- <b-badge :variant="variant"></b-badge> -->
 </div>
</template>

<script>

export default {
    name: 'EmptyComponent',
    props:{
        lang: Object
    },
    components: {


    },
    data () {
        return {
            name: "LivePanelComponent",
            libStatusOverall: ""
        }
    },
    computed: {
        libStatuses(){

            return this.$store.getters.libStatuses;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
    },
    created () {


    },
    watch: {
        libStatuses: {
            handler: function (newVal, oldVal) {
                
                let statusbar = "Libraries: <span class=\"green\">In sync</span>";
                let trig = false;
                for (let i = 0, lei = this.libStatuses.length; i < lei; i++) {

                    
                    if (this.libStatuses[i].status != "In Sync" && this.libStatuses[i].status != "Waiting") {
                        trig = true;
                    }
                }
                if (trig == true) {
                    statusbar = "Libraries: <span class=\"yellow\">In Use</span>";
                }

                this.libStatusOverall = statusbar;
            },
            deep: true


        },
    },
    methods: {



    }
}
</script>


<style lang="scss">
    .LivePanelComponent{
        .yellow {
            color: #E87C1E;
        }
    
        .green {
            color: #247f3e;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/LivePanelComponent.vue